import { useLiveRef } from 'base/useLiveRef';
import { useEffect } from 'react';

export const useResizeObserver = (
  target: HTMLElement | null,
  callback: (entry: ResizeObserverEntry) => void,
) => {
  const callbackRef = useLiveRef(callback);

  useEffect(() => {
    if (target === null) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const [entry] = entries;
      if (entry) {
        callbackRef.current(entry);
      }
    });
    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, [callbackRef, target]);
};
